module.exports = __webpack_public_path__ + "img/andreea-welcome-email.2dbe8a87.png";